import React from "react";

/**
 * ERF BrandMark
 * — Renders the ERF wordmark inside a gold-stroked circular emblem.
 * — When `/brand/erf-logo.png` exists, use it; otherwise show wordmark fallback.
 * Swap-in is a single-line change: set USE_IMG=true when the PNG is dropped in.
 */
const USE_IMG = true; // R1-visual — real ERF emblem asset (Slice 1)

export default function BrandMark({ size = 120, animated = false, className = "" }) {
  const px = size;
  if (USE_IMG) {
    return (
      <img
        src="/brand/erf_emblem_circular.jpg"
        alt="ERF Enterprises LLC"
        width={px}
        height={px}
        className={className}
        data-testid="brand-mark-img"
      />
    );
  }
  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: px, height: px }}
      aria-label="ERF Enterprises LLC"
      data-testid="brand-mark"
    >
      <svg viewBox="0 0 200 200" width={px} height={px} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="erf-gold" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#E7C067" />
            <stop offset="60%" stopColor="#B8892B" />
            <stop offset="100%" stopColor="#8A6420" />
          </linearGradient>
        </defs>
        {/* Outer emblem ring */}
        <circle cx="100" cy="100" r="92" fill="none" stroke="url(#erf-gold)" strokeWidth="3" />
        <circle cx="100" cy="100" r="82" fill="none" stroke="#B8892B" strokeOpacity="0.35" strokeWidth="1" />
        {/* Twin-peak roof silhouette (GC industry cue) */}
        <path
          d="M32 138 L78 92 L100 114 L122 92 L168 138 Z"
          fill="none"
          stroke="url(#erf-gold)"
          strokeWidth="3"
          strokeLinejoin="miter"
        />
        {/* Crossed hammer/rule feel: subtle T-square baseline */}
        <line x1="42" y1="150" x2="158" y2="150" stroke="#B8892B" strokeWidth="2" />
        <line x1="100" y1="150" x2="100" y2="164" stroke="#B8892B" strokeWidth="2" />
        {/* Wordmark */}
        <text
          x="100" y="82" textAnchor="middle"
          fontFamily="Barlow, sans-serif" fontWeight="800"
          fontSize="30" fill="url(#erf-gold)" letterSpacing="4"
        >ERF</text>
      </svg>
      {animated && (
        <span
          aria-hidden="true"
          className="absolute inset-[-10%] rounded-full erf-conic-sweep opacity-40 animate-conic-spin"
        />
      )}
    </div>
  );
}
